// 委托方提供材料清单
<template>
  <div class="projectFormLess" v-if="isComponentsShow">
    <!-- 第一行-项目名称 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
        <span>项目名称</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_project_name}}</span>
      </div>
    </div>
    <!-- 第三行--现场情况记录 -->
    <div class="oneRow" style="margin-bottom:10px">
      <div
        class="leftLabel"
        style="display:flex;justify-content:flex-start;width:100%;font-size:16px;align-items: center;"
      >
        <div style="display:flex;align-items: center;">
          <img style="width:16px" src="../../assets/image/icon_qd@2x.png" alt />
          <span>材料清单</span>
        </div>
        <!-- <el-button
          style="margin-left:60px"
          v-if="isSubmit"
          @click="handleAddTM"
          class="addTitleBtn"
        >添加条目</el-button>-->
      </div>
    </div>
    <!-- <div class="ProjectTextAreaBox" style="margin-bottom:50px;">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :header-cell-style="{background:'#F4F5F6'}"
      >
        <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="materialsname" label="材料名称">
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.materialsname}}</span>
            <span v-else>{{scope.row.materialsname}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" width="60" prop="have" label="有/无">
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.have}}</span>
            <span v-else>{{scope.row.have}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" width="60" prop="shape" label="形式">
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.shape}}</span>
            <span v-else>{{scope.row.shape}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" width="60" prop="num" label="数量">
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.num}}</span>
            <span v-else>{{scope.row.num}}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="80"
          prop="secrecy"
          label="是否保密"
        >
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.secrecy}}</span>
            <span v-else>{{scope.row.secrecy}}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="90"
          prop="addTime"
          label="提交时间"
        >
          <template slot-scope="scope">
            <span v-if="isSubmit" @click="tableClick(scope.row)">{{scope.row.addTime}}</span>
            <span v-else>{{scope.row.addTime}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" prop="content" label="操作">
          <template slot-scope="scope">
            <span
              v-if="isSubmit"
              @click="removeUser(scope.$index,scope.row)"
              style="cursor: pointer;color:#128BF1"
            >删除</span>
          </template>
        </el-table-column>
      </el-table>
      <p style="font-size:16px;color:#333;margin:30px 0;">我对所提供的材料原件、复印件的真实有效负责。</p>
    </div>-->
    <!-- 富文本 -->
    <div class="editUpdataBox ProjectTextAreaBox" style="width:100%" v-if="isSubmit">
      <el-input
        :disabled="!isSubmit"
        style="width:75%;min-width: 650px;"
        v-model="addFormData.existing_problems"
        :autosize="{minRows: 3}"
        type="textarea"
      ></el-input>
      <!-- <quill-editor
        ref="editQuillEditor"
        class="ql-editor"
        :disabled="!isSubmit"
        style="padding:0;margin-bottom:30px;width:75%"
        id="editdetailsquill"
        v-model="addFormData.existing_problems"
        :options="editorOptionedit"
      ></quill-editor>
      <el-upload
        class="avatar-uploader avatar-uploader-display"
        style="display:none;"
        action="#"
        ref="addUpLoad"
        :show-file-list="false"
        :before-upload="beforeAvatarUploadEdit"
      >
        <img v-if="addFormData.content" :src="addFormData.content" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>-->
    </div>
    <div v-else class="ql-container ql-snow" style="margin:20px 0">
      <div class="ql-editor" v-html="addFormData.existing_problems"></div>
    </div>
    <!-- 富文本 -->

    <!-- 签字 -->
    <!-- <div class="writeName" style="margin-bottom:25px">
      <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
      <span style="width:240px">被评价单位提供材料人员签字：</span>
      <img
        v-if="!addFormData.sign_receiving"
        @click="handleReceiverFlag1"
        style="width:66px;"
        src="../../assets/image/zaixianqianm@2x.png"
        alt
      />
      <img
        v-if="addFormData.sign_receiving"
        @click="handleReceiverFlag1(addFormData.sign_receiving)"
        style="width:66px;"
        :src="addFormData.sign_receiving"
        alt
      />
    </div>-->
    <!-- 第五行--上传附件 -->
    <div class="oneRow" style="margin-top:30px">
      <div class="leftLabel upLoadLabel">
        <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
        <span>上传附件</span>
      </div>
      <div class="rightInput">
        <upload-file
          :isSubmit="isSubmit"
          :imgList="this.addFormData.annex"
          :detailsImgList="detailsImgList"
          @my-upload-change="upLoadChange"
        ></upload-file>
      </div>
    </div>
    <div class="oneRow" style="margin-bottom:30px">
      <div class="leftLabel"></div>
      <div class="rightInput" style="display:flex;align-items:center">
        <div style="color:rgb(245, 95, 95);font-size:14px;">*请上传委托方提供材料清单,模板文件：</div>
        <a
          style="font-size:14px;"
          href="http://control.sxpz.vip/Template/委托方提供材料清单.doc"
        >委托方提供材料清单.doc</a>
      </div>
    </div>

    <!-- 审批备注 -->
    <div
      class="oneRow"
      style="margin-bottom:35px;margin-top:20px"
      v-if="addFormData.is_approve==1 "
    >
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>审批备注</span>
      </div>
      <div class="rightInput">
        <el-input v-model="approval_remark"></el-input>
      </div>
    </div>

    <!-- 按钮行 -->
    <div class="btnRow">
      <el-button @click="handleSubmit('1')" v-if="addFormData.is_edit!='1'">保存草稿</el-button>
      <el-button
        v-if="addFormData.withdraw_status=='1'"
        @click="handleProjectWithDraw"
        style="background-color:rgb(255, 26, 26);"
      >撤回</el-button>
      <el-button
        style="background-color:#40A0F2"
        @click="handleSubmit('0')"
        v-if="addFormData.is_edit!='1'"
      >提交</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('-1')"
        style="background-color:#f4a029"
      >驳回</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('1')"
        style="background-color:#40A0F2"
      >审批通过</el-button>
    </div>
    <!-- 按钮行 -->
    <!-- 签名组件 -->
    <sign-dialog
      @wirtDoen="handleWriteDone1"
      :visible.sync="receiverSignFlag1"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 签名组件 -->
    <!-- 整改通知单-添加弹窗 -->
    <el-dialog
      :visible.sync="dialogVisibleAdd"
      width="50%"
      class="addUserDia"
      :before-close="handleCloseAdd"
      @close="handleClosedAdd"
    >
      <div slot="title" class="header-title">
        <span class="title-age">添加条目</span>
      </div>
      <div class="diaContainer">
        <el-form ref="form" :model="AddUserForm" label-width="30%">
          <el-form-item label="材料名称">
            <el-input :placeholder="isSubmit ? '请输入依据标准' : ''" v-model="AddUserForm.materialsname"></el-input>
          </el-form-item>
          <el-form-item label="有/无">
            <el-radio-group v-model="AddUserForm.have">
              <el-radio label="有"></el-radio>
              <el-radio label="无"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="形式">
            <el-input :placeholder="isSubmit ? '请输入依据标准' : ''" v-model="AddUserForm.shape"></el-input>
          </el-form-item>
          <el-form-item label="数量">
            <el-input :placeholder="isSubmit ? '请输入依据标准' : ''" v-model="AddUserForm.num"></el-input>
          </el-form-item>
          <el-form-item label="是否保密">
            <el-radio-group v-model="AddUserForm.secrecy">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="提交时间">
            <el-date-picker
              :disabled="!isSubmit"
              v-model="AddUserForm.addTime"
              type="date"
              :placeholder="isSubmit ? '选择日期' : ''"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="dialogVisibleAdd = false">取 消</el-button>
        <el-button type="primary" v-if="diaFormType=='add'" @click="handleAddUser">添 加</el-button>
        <el-button type="primary" v-if="diaFormType=='edit'" @click="editUserForm">修 改</el-button>
      </div>
    </el-dialog>

    <!-- 查看进度 -->
    <project-flow
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectFlowLog="this.addFormData.approval_log"
      :projectName="this.addFormData.project_name"
      :companyName="this.addFormData.company_name"
      :projectId="this.addFormData.project_id"
      :stageCode="'24'"
    ></project-flow>
    <go-finance
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectId="this.addFormData.project_id"
    ></go-finance>

    <!-- 签名详情弹窗 -->
    <el-dialog
      :visible.sync="showDetailsDia"
      width="50%"
      class="addUserDia imgDetailsDia"
      :before-close="showDetailsDiaClose"
    >
      <div class="diaContainer">
        <img :src="showDetailsSign" alt />
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 引入富文本相关 start
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import * as Quill from 'quill'
//quill编辑器的字体
var fonts = [
  'SimSun',
  'SimHei',
  'Microsoft-YaHei',
  'KaiTi',
  'FangSong',
  'Arial',
  'Times-New-Roman',
  'sans-serif',
]
var Font = Quill.import('formats/font')
Font.whitelist = fonts //将字体加入到白名单
Quill.register(Font, true)
//图片缩放
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageResize', ImageResize)
// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ direction: 'rtl' }], // text direction

  [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ['link', 'image', 'video'],
  ['clean'], // remove formatting button
]
// 引入富文本相关 end
import ProjectFlow from '../ProjectFlow'
import SignDialog from '../SignDialog'
import UploadFile from '../UploadFile'
import GoFinance from '../GoFinance'
export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,

      showDetailsSign: '',
      showDetailsDia: false,

      S_project_name: '',
      approval_remark: '',
      isSubmit: true,
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      details_project_id: '',
      details_project_status: '',
      // 表格
      editTableIndex: '',
      diaFormType: 'add',
      // 表格
      isSubmit: true,
      detailsImgList: [],
      submitImgList: [],

      addFormData: {
        annex: '',
        notifier: '',
        notice_time: '',
        existing_problems: '',
        sign_receiving: '',
      },
      AddUserForm: {
        materialsname: '',
        have: '',
        shape: '',
        num: '',
        secrecy: '',
        addTime: '',
      },
      dialogVisibleAdd: false,
      // 签名
      receiverSignFlag1: false,
      receiverSignFlag2: false,
      writeDoneImg1: '',
      writeDoneImg2: '',
      // 签名
      topBarActive: '1',
      infop: '',
      member_id: '',
      token: '',
      value: '',
      tableData: [],
      // 富文本
      editorOptionedit: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  // alert('自定义图片')
                  // 调用element图片上传
                  document
                    .querySelector('.editUpdataBox .avatar-uploader-icon')
                    .click()
                } else {
                  this.quill.format('image', false)
                }
              },
            },
          },
          imageResize: {}, // 配置图片可缩放大小
        },
      },
      // 富文本
      isComponentsShow: false,
    }
  },
  methods: {
    // *撤回项目
    async handleProjectWithDraw() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails()
      }, this.timeDou)
    },
    selectPermitChange() {
      if (this.addFormData.permit_type == '1') {
        this.addFormData.permit_type_sub = ''
      }
      if (this.addFormData.permit_type == '2') {
        this.addFormData.permit_type_sub = '1'
      }
    },
    // 富文本上传
    async beforeAvatarUploadEdit(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2
      let param = new FormData()
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('member_id', this.member_id)
      param.append('file', file)
      // return console.log('param', param.get('access_token'))
      const { data: res } = await this.$axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/api/User/uploadImg',
        // data: param,
        data: param,
      })
      // return console.log('res', res)
      if (res.code != 200) return this.$message.error(res.datas.msg)

      let quill = this.$refs.editQuillEditor.quill
      // 如果上传成功
      if (res) {
        // 获取光标所在位置
        let length = quill.getSelection().index
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, 'image', res.datas.img_url)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        // 提示信息，需引入Message
        this.$message.error('图片插入失败')
      }
      console.log('asdasdasdas')
      return new Promise((resolve, reject) => {
        this.$refs['addUpLoad'].validate((valid) => {
          if (valid) {
            return resolve(true)
          } else {
            return reject(false)
          }
        })
      })
    },
    // *审批提交
    async handleExamine(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/client_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *编辑提交
    async handleSubmit(val) {
      // this.addFormData.existing_problems = JSON.stringify(this.tableData)
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)
        param.append('sign_receiving', this.addFormData.sign_receiving)
        param.append('annex', JSON.stringify(this.submitImgList))
        param.append('existing_problems', this.addFormData.existing_problems)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/client',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *获取详情
    async getProjectDetails() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/client_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // 判断是不是首次到此流程
      if (res.datas.info.is_new != 1) {
        this.addFormData = res.datas.info
      }
      // 判断禁用
      if (this.addFormData.is_draft != '1' && this.addFormData.is_edit == '1') {
        this.isSubmit = false
      } else {
        this.isSubmit = true
      }
      // 项目名称
      this.S_project_name = res.datas.info.project_name
      // 判断表格
      if (this.addFormData.existing_problems) {
        this.tableData = this.addFormData.existing_problems
      }
      // 判断文件上传
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      // 判断签名
      if (this.addFormData.sign_receiving == 'undefined') {
        this.addFormData.sign_receiving = ''
      }
      this.isComponentsShow = true
      console.log('整改通知单-详情', this.addFormData)
    },
    // 表格相关
    removeUser(index, row) {
      this.tableData.splice(index, 1)
      console.log(this.tableData)
    },
    handleAddTM() {
      this.diaFormType = 'add'
      this.dialogVisibleAdd = true
    },
    tableClick(row, column, event) {
      this.diaFormType = 'edit'
      this.editTableIndex = this.tableData.findIndex(
        (item) => item.id == row.id
      )
      this.AddUserForm = row
      this.dialogVisibleAdd = true
    },
    editUserForm() {
      this.tableData[this.editTableIndex] = this.AddUserForm
      this.dialogVisibleAdd = false
    },
    handleAddUser() {
      this.tableData.push({
        id: new Date().getTime(),
        materialsname: this.AddUserForm.materialsname,
        have: this.AddUserForm.have,
        shape: this.AddUserForm.shape,
        num: this.AddUserForm.num,
        secrecy: this.AddUserForm.secrecy,
        addTime: this.AddUserForm.addTime,
      })
      console.log(this.tableData)
      this.dialogVisibleAdd = false
    },
    // 表格相关

    // 签名
    handleWriteDone1(data) {
      this.addFormData.sign_receiving = data
    },

    handleReceiverFlag1(url) {
      if (!this.isSubmit) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag1 = true
    },
    handleReceiverSign() {},
    // 签名
    handleChange() {},
    handleTopBarClikc(val) {
      this.topBarActive = val
    },
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
    handleCloseAdd() {
      this.dialogVisibleAdd = false
    },
    handleClosedAdd() {
      this.AddUserForm = {
        materialsname: '',
        have: '',
        shape: '',
        num: '',
        secrecy: '',
        addTime: '',
      }
      this.diaFormType = 'add'
      this.editTableIndex = ''
    },
    showDetailsDiaClose() {
      this.showDetailsDia = false
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    if (this.details_project_status && this.details_project_id) {
      this.getProjectDetails()
    }
  },
  components: {
    SignDialog,
    UploadFile,
    ProjectFlow,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(../project/projectForm.less);
</style>